import { computeSplitPaymentValidation } from '../hooks/useSplitPaymentValidation';

export interface SplitPaymentReadinessInput {
  /** Tarjeta elegida en la primera sección (vacío si no eligió). */
  firstCardId?: string;
  /** Tarjeta elegida en la segunda sección (vacío si no eligió). */
  secondCardId?: string;
  firstAmount?: number;
  secondAmount?: number;
  /** `totals.total` inicial del pedido: sin cuotas con interés. Las cuotas pueden subirlo, nunca bajarlo. */
  total: number;
  firstCvv?: string;
  secondCvv?: string;
  /** La tarjeta necesita CVV (las nuevas de la sesión llevan el CVV en su token). */
  firstNeedsCvv: boolean;
  secondNeedsCvv: boolean;
}

const isCvvComplete = (cvv: string | undefined): boolean => {
  const length = cvv?.length ?? 0;
  return length === 3 || length === 4;
};

/**
 * ¿Se puede llamar a `pre-initiate` en "Pagar con 2 tarjetas"?
 * Solo cuando ambas tarjetas están elegidas, ambos montos cargados, la suma iguala el total inicial
 * y cada CVV requerido está completo. Antes de eso, la respuesta sería engañosa.
 */
export const isSplitReadyForPreInitiate = (input: SplitPaymentReadinessInput): boolean => {
  if (!input.firstCardId || !input.secondCardId) return false;
  if (input.firstNeedsCvv && !isCvvComplete(input.firstCvv)) return false;
  if (input.secondNeedsCvv && !isCvvComplete(input.secondCvv)) return false;
  return computeSplitPaymentValidation({
    total: input.total,
    amounts: [input.firstAmount, input.secondAmount],
  }).isValid;
};
